import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RequestsView from '../views/RequestsView.vue'
import RequestDetailsView from '../views/RequestDetailsView.vue'
import ProfileView from '../views/ProfileView.vue'
import SettingsView from '../views/SettingsView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/requests',
    name: 'requests',
    component: RequestsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/requests/:orderNumber',
    name: 'request-details',
    component: RequestDetailsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0, behavior: 'auto' }
  }
})

router.beforeEach(async (to, from, next) => {
  await store.dispatch('auth/bootstrap')

  const isAuth = store.getters['auth/isAuthenticated']

  if (to.meta.requiresAuth && !isAuth) {
    next('/login')
    return
  }

  if (to.path === '/login' && isAuth) {
    next('/')
    return
  }

  next()
})

export default router